import {
  CARESEEKER_TYPE,
  SEARCH_TYPE_CARE,
  SEARCH_TYPE_HOME_CARE,
  SEARCH_TYPE_HOSPITAL,
  SEARCH_TYPE_MEDICAL_SUPPLIES,
  SEARCH_TYPE_PSYCHIATRIC_CARE,
  SEARCH_TYPE_REHABILITATION,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_MOBILE_CARE,
  SOLUTION_SHORT_TERM_STATIC_CARE,
  SOLUTION_STATIC_CARE,
} from "core/consts";
import { PatientWhitelistDefinition } from "core/types";

export const shortTermCareWhitelist: PatientWhitelistDefinition = [
  {
    country: "DE",
    search_type: SEARCH_TYPE_CARE,
    solutions: [SOLUTION_SHORT_TERM_STATIC_CARE, SOLUTION_STATIC_CARE],
  },
];

// export const healthInsuranceWhitelist: PatientWhitelistDefinition = [
//   {
//     country: "FR",
//     search_type: SEARCH_TYPE_HOSPITAL,
//   },
// ];

export const insuranceWhitelist: PatientWhitelistDefinition = [
  {
    country: "DE",
    search_type: SEARCH_TYPE_CARE,
  },
  {
    country: "DE",
    search_type: SEARCH_TYPE_HOSPITAL,
  },
  {
    country: "DE",
    search_type: SEARCH_TYPE_REHABILITATION,
  },
  {
    country: "DE",
    search_type: SEARCH_TYPE_MEDICAL_SUPPLIES,
  },
  {
    country: "DE",
    search_type: SEARCH_TYPE_HOME_CARE,
  },
];

export const socialHelpRecipientBoolWhitelist: PatientWhitelistDefinition = [
  {
    country: "DE",
    search_type: SEARCH_TYPE_CARE,
    solutions: [
      SOLUTION_MOBILE_CARE,
      SOLUTION_SHORT_TERM_STATIC_CARE,
      SOLUTION_STATIC_CARE,
    ],
  },
  {
    country: "DE",
    search_type: SEARCH_TYPE_PSYCHIATRIC_CARE,
  },
];
export const reliefServiceBoolWhitelist: PatientWhitelistDefinition = [
  {
    country: "DE",
    search_type: SEARCH_TYPE_CARE,
  },
  {
    country: "DE",
    search_type: SEARCH_TYPE_PSYCHIATRIC_CARE,
  },
];

export const reimbursment_for_help_at_homeWhitelist: PatientWhitelistDefinition =
  [
    {
      country: "DE",
      search_type: SEARCH_TYPE_CARE,
      solutions: [SOLUTION_HELP_AT_HOME, SOLUTION_MOBILE_CARE],
    },
    {
      country: "DE",
      search_type: SEARCH_TYPE_PSYCHIATRIC_CARE,
    },
  ];

export const reimbursment_securedWhitelist: PatientWhitelistDefinition = [
  {
    country: "DE",
    search_type: SEARCH_TYPE_CARE,
    solutions: [SOLUTION_MOBILE_CARE],
  },
  {
    country: "DE",
    search_type: SEARCH_TYPE_PSYCHIATRIC_CARE,
  },
];

export const carelevelWhitelist: PatientWhitelistDefinition = [
  { country: "DE" },
];

export const grantsWhitelist: PatientWhitelistDefinition = [
  {
    country: "DE",
    sender_type: CARESEEKER_TYPE.HOSPITAL,
  },
];

export const medicalCardWhitelist: PatientWhitelistDefinition = [
  {
    country: "DE",
    sender_type: CARESEEKER_TYPE.HOSPITAL,
  },
  {
    country: "DE",
    sender_type: CARESEEKER_TYPE.PROVIDER_SEARCH,
  },
];
